import { GlowFilter } from 'pixi-filters';
import type { Container } from 'pixi.js';
import { setContainerParent } from '../transform-utils';
import { getFilters } from '../filter-utils';

/**
 * @param container container to highlight with glow effect.
 * @param newParent progressContainer will be re-parented to this container until reset.
 * @param onResetCallback called when reset function is completed.
 * @returns function to reset highlight and return container to original parent.
 */
export function highlightContainer(
  container: Container,
  newParent?: Container,
  onResetCallback?: () => void,
): () => void {
  const originalParent = container.parent;
  if (newParent && originalParent) {
    setContainerParent(container, newParent);
  }

  const glowFilter = new GlowFilter({ color: 0xffff00, distance: 40, outerStrength: 0 });
  container.filters = [...getFilters(container), glowFilter];

  const tween = container.tweenCreate(glowFilter).to({ outerStrength: 4 }, 333, 'quadOut', true);

  return () => {
    if (tween.isRunning) tween.stop();

    container
      .tweenCreate(glowFilter)
      .to(
        {
          outerStrength: 0,
        },
        500,
        'quadOut',
        true,
      )
      .onComplete.addOnce(() => {
        glowFilter.destroy();
        container.filters = [];
        if (newParent && originalParent) {
          setContainerParent(container, originalParent);
        }
        onResetCallback?.();
      });
  };
}
